import { render } from "./Ratios.vue?vue&type=template&id=92892bfe"
import script from "./Ratios.vue?vue&type=script&lang=js"
export * from "./Ratios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__